import { useChartControls } from "../ChartControlsContext";
import { CollapsibleRangeSelector } from "./CollapsibleRangeSelector";

interface Props {
  compact?: boolean;
  constrainWidth?: boolean;
  fullWidth?: boolean;
}

export const RangeControl = ({
  compact = false,
  constrainWidth,
  fullWidth,
}: Props) => {
  const { rangeProps, availableDateRanges, availableCompactDateRanges } =
    useChartControls();

  return (
    <CollapsibleRangeSelector
      rangeProps={rangeProps}
      intervalTypes={availableDateRanges}
      compactIntervalTypes={availableCompactDateRanges}
      compact={compact}
      constrainWidth={constrainWidth}
      fullWidth={fullWidth}
    />
  );
};
